<template>
  <div>
    <div class="w-100 my-2 p-2 text-left bg-light">
      <button class="btn btn-outline-success btn-sm" @click="clickEpaperList(memthed.insert)">新增</button>
      <button class="btn btn-outline-primary btn-sm ml-2">搜尋</button>
      <button class="btn btn-outline-warning btn-sm ml-2">清除搜尋條件</button>
    </div>
    <div class="w-100">
      <table class="table table-bordered table-sm">
        <thead>
          <tr>
            <th>管理</th>
            <th>發送日期</th>
            <th>信件名稱</th>
            <th>信件主旨</th>
            <th>同步發送官網</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(epaper, index) in epaperList">
            <td>
              <div class="d-flex align-items-center justify-content-between">
                <span>{{index + 1}}</span>
                <div class="flex-fill d-flex align-items-center justify-content-center">
                  <button class="btn btn-sm btn-outline-primary"
                    @click="clickEpaperList(epaper)">管理</button>
                </div>
              </div>
            </td>
            <td>{{epaper.sendTime}}</td>
            <td>{{epaper.inname}}</td>
            <td>{{epaper.title}}</td>
            <td>{{epaper.sync}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import ctrl from "@/js/epaper/epaperList"
  export default ctrl;

</script>
